module.exports = __webpack_public_path__ + "img/d201007-2.05653c88.jpg";